// TabContent1.js
import React, { useState, useEffect } from 'react';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import Subheading from '../../../../theme/text/Subheading';
import SelectGroup from '../../../../theme/Select/SelectGroup';
import NumberInput from '../../../../theme/inputs/NumberInput';
import { useTheme } from '@emotion/react';
import Text from '../../../../theme/text/Text';
import { useTranslation } from 'react-i18next';
import { Box, InputBase, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { tokens } from '../../../../../theme';
import { useDispatch, useSelector } from 'react-redux';
import { setTabErrors } from '../../../../../newapi/global/progressionTabSlice';
import * as yup from "yup";
import ShValidatedInput from '../../../../theme/inputs/ShValidatedInput';
import { yupRequired } from '../../../../../utils/validation';
import cx from "classnames"
import { useGetRelationsQuery } from '../../../../../newapi/global/relation/relationSlice';
import ShValidatedInputDropdown from '../../../../theme/dropdowns/ShValidatedInputDropdown';
import EMGeneralExplainerBox from "../../../ModalsPopover/explainers/EMGeneralExplainerBox";
import { ENV_TYPES } from "../../../Sidebar";
import Shbutton from '../../../../theme/buttons/Shbutton';
import { useCreateWebshopCredentialsWithOAuthMutation } from '../../../../../newapi/webshop/webshopSlice';
import { useGetSettingsQuery } from '../../../../../newapi/global/generalApiSlice';

/**
 * TabContent1 Component
 * 
 * Props:
 * - handleDataUpdate: Function, updates the data in the Redux state.
 * - handleNext: Function, navigates to the next tab.
 */
const Content = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const data = { ...props.data };
    const dispatch = useDispatch();

    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];
    const [showCreateproducts, setShowCreateProducts] = useState(false);
    const [showUpdateproducts, setShowUpdateProducts] = useState(false);
    const { data: settings} = useGetSettingsQuery("webshop_sync_");
    const { data: trackAndTraceSettings } = useGetSettingsQuery("allow_track_and_trace_mails");
    const showTrackAndTraceMails = trackAndTraceSettings?.find(s => s.key === "allow_track_and_trace_mails")?.value === "true";

    useEffect(() => {
        if(settings){
            for(let i = 0; i < settings.length; i++){
                const setting = settings[i];
                if(setting.key === "webshop_sync_create_products"){
                    if(setting.value === 'true'){
                        setShowCreateProducts(true);
                    } else {
                        handleChange("syncCreateProducts","false")
                    }
                } else if(setting.key === "webshop_sync_update_products"){
                    if(setting.value === 'true'){
                        setShowUpdateProducts(true);
                    } else {
                        handleChange("syncUpdateProducts","false")
                    }
                }
            }
        }
    }, [settings])

    const handleInput = (key, val) => {
        props.handleDataUpdate({ [key]: val });
        dispatch(setTabErrors({ ...props.errors, [key]: '' }));
    };

    const [webshopCredentialsInfo, setWebshopCredentialsInfo] = useState(data);

    const handleChange = (key, val) => {
        setWebshopCredentialsInfo({
            ...webshopCredentialsInfo,
            [key]: val
        });
        dispatch(setTabErrors({ ...props.errors, [key]: '' }));
    }

    useEffect(() => {
        props.handleDataUpdate(webshopCredentialsInfo);
    }, [webshopCredentialsInfo])

    const [createWebshopCredentialsWithOAuth,{isLoading}] = useCreateWebshopCredentialsWithOAuthMutation();

    const handleOAuth = () => {
        if(isLoading) return;
        createWebshopCredentialsWithOAuth(webshopCredentialsInfo).then((res) => {
            if (res.data?.success) {
                window.location.href = res.data?.url;
            }
        });
    }

    return (
        <div>
            <Box 
                sx={{
                    width:1,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:220,
                        flexShrink:0,
                        display:"flex",
                        alignItems:"center"
                    }}
                >
                    <Text>{t("sync_orders")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ToggleButtonGroup
                                color={webshopCredentialsInfo.syncOrders === 'true' ? "green" : "red"}
                                value={webshopCredentialsInfo.syncOrders === 'true' ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("syncOrders", value)}
                                aria-label="Active"
                                className={cx(`${webshopCredentialsInfo.syncOrders}`, {
                                    'active': webshopCredentialsInfo.syncOrders === 'true'
                                })}
                                sx={{
                                    width:1,
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        width:1,
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        width:1,
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                    
                </Box>
            </Box>
            {(isRelation && showUpdateproducts) &&
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:220,
                        flexShrink:0,
                        display:"flex",
                        alignItems:"center"
                    }}
                >
                    <Text>{t("sync_products")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,

                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ToggleButtonGroup
                                color={webshopCredentialsInfo.syncProducts === 'true' ? "green" : "red"}
                                value={webshopCredentialsInfo.syncProducts === 'true' ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("syncProducts", value)}
                                aria-label="Active"
                                className={cx(`${webshopCredentialsInfo.syncProducts}`, {
                                    'active': webshopCredentialsInfo.syncProducts === 'true'
                                })}
                                sx={{
                                    width:1,
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        width:1,
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        width:1,
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                    
                </Box>
            </Box>
            }           
            {(isRelation && showCreateproducts) &&
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:220,
                        flexShrink:0,
                        display:"flex",
                        alignItems:"center"
                    }}
                >
                    <Text>{t("sync_create_products")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,

                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ToggleButtonGroup
                                color={webshopCredentialsInfo.syncCreateProducts === 'true' ? "green" : "red"}
                                value={webshopCredentialsInfo.syncCreateProducts === 'true' ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("syncCreateProducts", value)}
                                aria-label="Active"
                                className={cx(`${webshopCredentialsInfo.syncCreateProducts}`, {
                                    'active': webshopCredentialsInfo.syncCreateProducts === 'true'
                                })}
                                sx={{
                                    width:1,
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        width:1,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        width:1,
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                    
                </Box>
            </Box>
            }
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:220,
                        flexShrink:0,
                        display:"flex",
                        alignItems:"center"
                    }}
                >
                    <Text noBreak>{t("sync_stock")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ToggleButtonGroup
                                color={webshopCredentialsInfo.syncStock === 'true' ? "green" : "red"}
                                value={webshopCredentialsInfo.syncStock === 'true' ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("syncStock", value)}
                                aria-label="Active"
                                className={cx(`${webshopCredentialsInfo.syncStock}`, {
                                    'active': webshopCredentialsInfo.syncStock === 'true'
                                })}
                                sx={{
                                    width:1,
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        width:1,
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        width:1,
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                    
                </Box>
            </Box>
            {!isRelation &&
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:220,
                    }}
                >
                    <Text>{t("snooze_all_incoming_orders")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ToggleButtonGroup
                                color={webshopCredentialsInfo?.snooze === true ? "green" : "red"}
                                value={webshopCredentialsInfo?.snooze === true ? "true" : "false"}
                                exclusive
                                onChange={(e,value) => handleChange("snooze", value === "true")}
                                aria-label="Active"
                                className={cx(`${webshopCredentialsInfo?.snooze}`, {
                                    'active': webshopCredentialsInfo?.snooze === true
                                })}
                                sx={{
                                    background: colors.red[100],
                                    padding:0.5,
                                    borderRadius:5,
                                    transition:"250ms",
                                    "&.active" : {
                                        background:colors.green[100],
                                        transition:"250ms",
                                    },
                                }}
                            >
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.green[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.red[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="false">
                                    {t('inactive')}
                                </ToggleButton>
                                <ToggleButton 
                                    sx={{
                                        padding:0,
                                        paddingX:2,
                                        border:0,
                                        lineHeight:"32px",
                                        textTransform:"unset",
                                        borderRadius:"32px !important",
                                        color:colors.red[400],
                                        transition:"250ms",
                                        "&.Mui-selected,&.Mui-selected:hover" : {
                                            background:colors.green[400],
                                            color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                        }
                                    }}
                                    value="true"
                                >
                                    {t('active')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                    
                </Box>
            </Box>
            }
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:220,
                        display:"flex",
                        alignItems:"center"
                    }}
                >
                    <Text>{t("sync_virtual_stock")}</Text>
                    <EMGeneralExplainerBox title={t('em_syncvirtualstock_title')} text={t('em_syncvirtualstock_text')}/>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        borderRadius:4,
                        display:"flex",
                        height:32,
                    }}
                >
                    <NumberInput btnSize={"24"}
                        maxWidth={160}
                        value={webshopCredentialsInfo?.virtualSyncAmount}
                        change={(e) => handleChange("virtualSyncAmount", e)}
                    />
                </Box>
            </Box>
            {showTrackAndTraceMails &&
            <Box
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                <Box
                    sx={{
                        width:220,
                        flexShrink:0,
                        display:"flex",
                        alignItems:"center"
                    }}
                >
                    <Text>{t("send_track_and_trace_email")}</Text>
                </Box>
                <Box
                    sx={{
                        flex:1,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ToggleButtonGroup
                        color={webshopCredentialsInfo?.sendTrackAndTraceEmail === true ? "green" : "red"}
                        value={webshopCredentialsInfo?.sendTrackAndTraceEmail === true ? "true" : "false"}
                        exclusive
                        onChange={(e,value) => handleChange("sendTrackAndTraceEmail", value === "true")}
                        aria-label="Active"
                        className={cx(`${webshopCredentialsInfo?.sendTrackAndTraceEmail}`, {
                            'active': webshopCredentialsInfo?.sendTrackAndTraceEmail === true
                        })}
                        sx={{
                            width:1,
                            background: colors.red[100],
                            padding:0.5,
                            borderRadius:5,
                            transition:"250ms",
                            "&.active" : {
                                background:colors.green[100],
                                transition:"250ms",
                            },
                        }}
                    >
                        <ToggleButton
                            sx={{
                                width:1,
                                padding:0,
                                paddingX:2,
                                border:0,
                                lineHeight:"32px",
                                textTransform:"unset",
                                borderRadius:"32px !important",
                                color:colors.green[400],
                                transition:"250ms",
                                "&.Mui-selected,&.Mui-selected:hover" : {
                                    background:colors.red[400],
                                    color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                }
                            }}
                            value="false">
                            {t('inactive')}
                        </ToggleButton>
                        <ToggleButton
                            sx={{
                                width:1,
                                padding:0,
                                paddingX:2,
                                border:0,
                                lineHeight:"32px",
                                textTransform:"unset",
                                borderRadius:"32px !important",
                                color:colors.red[400],
                                transition:"250ms",
                                "&.Mui-selected,&.Mui-selected:hover" : {
                                    background:colors.green[400],
                                    color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                }
                            }}
                            value="true"
                        >
                            {t('active')}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
            </Box>
            }
            {(data.webshop_type !== "shopify" && data.webshop_type !== "bol") ? <></> :
            <Box sx={{ display:"flex", mt:2, gap: 2 }}>
                <Shbutton

                    className={"group-btn"}
                    color={"primary"}
                    onClick={() => handleOAuth()}
                    isLoading={isLoading}
                    variant="contained"
                    tabindex={1}
                >
                    {t('authorize')}
                </Shbutton>

            </Box>
            }
    </div>
    );
};

const Sync = (props) => {
    const data = props.data;
    const { t } = useTranslation();

    return (
        <ProgressionTab 
        tabId="tabSync" 
        subtitle={t("synchronisations")} 
        step={3}
        maxSteps={3}
        //schema={schema}
    >
        <Content />
    </ProgressionTab>
    )
}

export default Sync;

